// extracted by mini-css-extract-plugin
module.exports =  {"building-link":"_32bbee5fda--building-link--ai_oJ"};